module.exports = __webpack_public_path__ + "img/rango.3151cf06.jpg";